export const AllWebinarsHeader = [
  { name: 'index', label: 'ردیف', isSortable: false, align: 'center' },
  { name: 'title', label: 'عنوان', isSortable: false, align: 'center' },
  { name: 'liveAt', label: 'تاریخ درخواست', isSortable: true, align: 'center' },
  { name: 'liveAt', label: 'تاریخ برگزاری', isSortable: true, align: 'center' },
  { name: 'hour', label: 'ساعت ', isSortable: false, align: 'center' },
  { name: 'marketerCode', label: 'کد بازاریاب', isSortable: false, align: 'center' },
  { name: 'sellProduct', label: 'قصد فروش', isSortable: false, align: 'center' },
  { name: 'hostDomain', label: 'زیر دامنه', isSortable: false, align: 'center' },
  { name: 'category', label: 'دسته بندی', isSortable: false, align: 'center' },
  { name: 'status', label: 'وضعیت', isSortable: false, align: 'center' },
  { name: 'reviewResult', label: 'نتیجه بررسی', isSortable: false, align: 'center' },
  { name: 'action', label: 'عملیات', isSortable: false, align: 'center' },
];

export const NewWebinarsHeader = [
  { name: 'index', label: 'ردیف', isSortable: false, align: 'center' },
  { name: 'title', label: 'عنوان', isSortable: false, align: 'center' },
  { name: 'liveAt', label: 'تاریخ درخواست', isSortable: true, align: 'center' },
  { name: 'liveAt', label: 'تاریخ برگزاری', isSortable: true, align: 'center' },
  { name: 'hour', label: 'ساعت ', isSortable: false, align: 'center' },
  { name: 'marketerCode', label: 'کد بازاریاب', isSortable: false, align: 'center' },
  { name: 'sellProduct', label: 'قصد فروش', isSortable: false, align: 'center' },
  { name: 'hostDomain', label: 'زیر دامنه', isSortable: false, align: 'center' },
  { name: 'category', label: 'دسته بندی', isSortable: false, align: 'center' },
  { name: 'status', label: 'وضعیت', isSortable: false, align: 'center' },
  { name: 'action', label: 'عملیات', isSortable: false, align: 'center', width: '200px' },
];
